import type { ColorThresholds, TimerSnapshot } from './types';

export type TimerTone = 'green' | 'yellow' | 'red';

export function formatTimer(snapshot: TimerSnapshot): string {
  const minutes = Math.floor(snapshot.displaySeconds / 60);
  const seconds = snapshot.displaySeconds % 60;
  return `${snapshot.isOvertime ? '+' : ''}${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function getTimerTone(snapshot: TimerSnapshot, thresholds: ColorThresholds): TimerTone {
  if (snapshot.isOvertime || snapshot.progress <= thresholds.danger) return 'red';
  if (snapshot.progress <= thresholds.warning) return 'yellow';
  return 'green';
}

export function clampInteger(value: string, min: number, max: number): number {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed)) return min;
  return Math.max(min, Math.min(max, parsed));
}
